import { EnumTipoAutenticacaoEnvioPortalUnico } from "@catalogo/features/operacional/enums/enum-entities";

export class DadosAutenticacaoPortalUnico
{
    public constructor(
        public accessToken: string,
        public xCSRFToken: string,
        public xCSRFExpiracao: string,
        public tipoAutenticacao: EnumTipoAutenticacaoEnvioPortalUnico
    ) { }
}
